import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import DashLayout from '../../components/DashLayout';

const nav = [
  { to: '/super-admin', icon: '📊', label: 'Dashboard' },
  { to: '/super-admin/businesses', icon: '🏢', label: 'Businesses' },
  { to: '/super-admin/payments', icon: '💰', label: 'Payments' },
  { to: '/super-admin/invoice-report', icon: '🧾', label: 'Invoice Report' },
  { to: '/super-admin/tickets', icon: '🎫', label: 'Support Tickets' },
  { to: '/super-admin/reports', icon: '🚩', label: 'Visitor Reports' },
  { to: '/super-admin/plans', icon: '📦', label: 'Plans' },
  { to: '/super-admin/agents', icon: '👥', label: 'Agent Requests' }
];

export default function Reports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadReports(); }, []);

  const loadReports = () => {
    axios.get('/api/super-admin/visitor-reports').then(r => {
      setReports(r.data.data || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  const banVisitor = async (report) => {
    if (!window.confirm(`Ban visitor ${report.visitor_name || report.visitor_email}?`)) return;
    try {
      await axios.post('/api/super-admin/ban-visitor', {
        visitor_id: report.visitor_id,
        business_id: report.business_id,
        reason: report.reason
      });
      toast.success('Visitor banned!');
      loadReports();
    } catch { toast.error('Failed to ban'); }
  };

  const ignoreReport = async (id) => {
    await axios.put(`/api/super-admin/visitor-reports/${id}/ignore`).catch(() => {});
    loadReports();
  };

  return (
    <DashLayout navItems={nav} role="Super Admin">
      <div style={{ padding: 28 }}>
        <div style={{ marginBottom: 24 }}>
          <h1 style={{ fontSize: 22, fontWeight: 700 }}>🚩 Visitor Reports</h1>
          <p style={{ color: '#555', fontSize: 13, marginTop: 4 }}>Visitors reported by agents for review</p>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 60, color: '#333' }}>Loading...</div>
        ) : reports.length === 0 ? (
          <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 12, padding: 60, textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
            <div style={{ color: '#555' }}>No reports yet</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {reports.map(r => (
              <div key={r.id} style={{ background: '#111', border: `1px solid ${r.ban_id ? '#ff444433' : '#1e1e1e'}`, borderRadius: 12, padding: '16px 20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                  <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                    <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,68,68,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>🚩</div>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 600 }}>{r.visitor_name || 'Unknown'}</div>
                      <div style={{ fontSize: 12, color: '#555' }}>{r.visitor_email}</div>
                    </div>
                  </div>
                  {r.ban_id ? (
                    <span style={{ fontSize: 11, padding: '3px 10px', borderRadius: 20, background: 'rgba(255,68,68,0.1)', color: '#ff4444', fontWeight: 600 }}>BANNED</span>
                  ) : (
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button onClick={() => banVisitor(r)}
                        style={{ padding: '7px 16px', background: 'rgba(255,68,68,0.1)', border: '1px solid #ff4444', color: '#ff4444', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                        🚫 Ban Visitor
                      </button>
                      <button onClick={() => ignoreReport(r.id)}
                        style={{ padding: '7px 16px', background: '#1a1a1a', border: '1px solid #1e1e1e', color: '#555', borderRadius: 8, fontSize: 12, cursor: 'pointer' }}>
                        ✅ Ignore
                      </button>
                    </div>
                  )}
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10, background: '#0d0d0d', borderRadius: 8, padding: 12 }}>
                  {[
                    ['🌍 Country', r.country || 'Unknown'],
                    ['🌆 City', r.city || 'Unknown'],
                    ['🖥️ IP Address', r.ip_address || 'Unknown'],
                    ['🏢 Business', r.company_name],
                    ['👤 Reported by', r.agent_name || 'Business Admin'],
                    ['📅 Date', new Date(r.created_at).toLocaleString('en-IN')],
                    ['💬 Reason', r.reason],
                  ].map(([label, val]) => (
                    <div key={label}>
                      <div style={{ fontSize: 10, color: '#444', marginBottom: 2 }}>{label}</div>
                      <div style={{ fontSize: 12, color: '#888' }}>{val || '—'}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </DashLayout>
  );
}
